import axios from "axios";
import AuthConfig from "./AuthConfig";
import AuthStore from "./Store";
import AuthState from "./Enums/AuthState";

const AWSOAuthFlowHelper = {

};

AWSOAuthFlowHelper.start = () => {
	if (AWSOAuthFlowHelper.hasCode()) {
		AuthStore.meta.state.set(AuthState.LOGGING_IN);
		AWSOAuthFlowHelper.processCode();
	}
};

// @return Promise if code is present and processing is done.
AWSOAuthFlowHelper.hasCode = () => {
	const url = new URL(window.location.href);
	const code = url.searchParams.get("code");
	return code !== null;
};
AWSOAuthFlowHelper.processCode = () => {
	const url = new URL(window.location.href);
	const code = url.searchParams.get("code");
	if (code !== null) {
		const postParams = {
			grant_type: "authorization_code",
			client_id: AuthConfig.clientId,
			redirect_uri: AuthConfig.redirectUrl,
			code: code,
			scope: AuthConfig.scopes
		};

		const postString = AWSOAuthFlowHelper._objectToPostString(postParams);

		const postHeaders = {
			headers: {
				"content-Type": "application/x-www-form-urlencoded",
				accept: "*/*"
			}
		};

		axios.post(AuthConfig.tokenUrl, postString, postHeaders)
			.then(response => {
				const token = AuthStore.helpers._generateTokenFromAWSOAuthResult(response.data);

				AuthStore.token.set(token);
				AuthStore.actions.save();

				AuthStore.actions.updateCurrentUser().then(() => {
					window.location = window.location.origin;
				});
			})
			.catch(error => {
				AWSOAuthFlowHelper._logoutErrorHandler(AuthConfig.tokenUrl, error);
			})
			.finally(() => {
				AuthStore.actions.save();
			});
		return true;
	}
	return false;
};

AWSOAuthFlowHelper.getUserInfo = (accessToken = null) => {
	return new Promise((resolve, reject) => {
		const getHeaders = {
			headers: {
				Authorization: "Bearer " + accessToken
			}
		};
		console.log(AuthConfig.userinfoUrl);
		axios.get(AuthConfig.userinfoUrl, getHeaders)
			.then(response => {
				resolve(response);
			})
			.catch(error => {
				reject(error);
			});
	});
};

AWSOAuthFlowHelper._objectToPostString = (obj) => {
	let str = "";
	for (const key in obj) {
		str += key + "=" + obj[key] + "&";
	}
	return str.substr(0, str.length - 1);
};

AWSOAuthFlowHelper._logoutErrorHandler = (url, error) => {
	console.error("Error in request: " + url);
	console.error(error.response);
	AuthStore.actions.logout(true);
};

export default AWSOAuthFlowHelper;
